/* Support: metadata rows, not paragraphs. Tokens only (ADR-0007). */

.steps {
  display: grid;
  gap: 8px;
  margin: 0 0 14px;
  padding-left: 20px;
  color: var(--ink-2);
  font-size: var(--t-body);
  line-height: 1.45;
}

.write {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: var(--h-ctl);
  padding: 0 14px;
  border-radius: 6px;
  background: var(--accent);
  color: var(--on-fill);
  font-size: var(--t-dense);
  font-weight: 600;
  text-decoration: none;
}

.write:hover {
  background: var(--accent-h);
}

.write:focus-visible {
  outline: 2px solid var(--focus);
  outline-offset: 2px;
}

.none {
  margin: 0;
  color: var(--muted);
  font-size: var(--t-dense);
}

.rows {
  display: grid;
  gap: 0;
  margin: 0;
}

.row {
  display: grid;
  grid-template-columns: minmax(130px, 38%) 1fr;
  align-items: baseline;
  gap: 4px 14px;
  padding: 8px 0;
  border-bottom: 1px solid var(--line);
  font-size: var(--t-dense);
}

.row:last-child {
  border-bottom: 0;
}

.row dt {
  color: var(--muted);
  font-weight: 600;
}

.row dd {
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  gap: 8px;
  margin: 0;
  color: var(--ink);
  overflow-wrap: anywhere;
}

.row a,
.after a {
  color: var(--accent);
  text-underline-offset: 3px;
}

.retry {
  min-height: 28px;
  padding: 0 10px;
  border: 1px solid var(--line-2);
  border-radius: 6px;
  background: var(--panel);
  color: var(--ink);
  font: inherit;
  font-size: var(--t-dense);
  cursor: pointer;
}

.guides {
  width: 100%;
  margin: 0 0 12px;
  border-collapse: collapse;
  font-size: var(--t-dense);
}

.guides th,
.guides td {
  padding: 8px 10px;
  border-bottom: 1px solid var(--line);
  text-align: left;
  vertical-align: middle;
}

.guides thead th {
  color: var(--muted);
  font-size: var(--t-min);
  font-weight: 600;
}

.guides tbody th {
  color: var(--ink);
  font-weight: 600;
}

.after {
  display: flex;
  align-items: flex-start;
  gap: 10px;
  margin: 0;
  color: var(--ink-2);
  font-size: var(--t-dense);
}

.after svg {
  flex-shrink: 0;
  margin-top: 2px;
  color: var(--muted);
}

@media (max-width: 560px) {
  .row {
    grid-template-columns: 1fr;
  }
}

.actions {
  display: inline-flex;
  align-items: center;
  gap: 12px;
}
